export function customEvent(name, opts) {
    let params = Object.assign({bubbles: true, cancelable: false, detail: null}, opts);
    if (typeof CustomEvent === "function") {
        return new CustomEvent(name, params);
    }
    // We're in IE...
    let evt = document.createEvent("CustomEvent");
    evt.initCustomEvent(name, params.bubbles, params.cancelable, params.detail);
    return evt;
}

export default customEvent;
